import { API } from "./api"

export default (path) => {
    return `${API}/static${path}`
}